import React from 'react'
import { Link } from 'react-router-dom'
import { isMobile, l } from '@manychat/manyui'

import { InstagramFtdmForAlphaUsersStopNotification } from 'common/core/components/NotifyBar/NotifyInterfaces'
import { typedRouting } from 'utils/router'

import cm from './InstagramFollowReplyStopped.module.css'

interface InstagramFollowReplyStoppedProps {
  notification: InstagramFtdmForAlphaUsersStopNotification
}

const getText = (notification: InstagramFtdmForAlphaUsersStopNotification) => {
  if (isMobile) {
    return l.translate('Say ‘hi to new followers’ stopped.')
  }

  return notification.data.flow_type === 'easy_builder'
    ? l.translate('Automation ‘{name}’ has stopped working.', {
        name: notification.data.flow_name,
      })
    : l.translate('Trigger ‘{name}’ has stopped working.', {
        name: notification.data.flow_name,
      })
}

export const InstagramFollowReplyStopped = ({ notification }: InstagramFollowReplyStoppedProps) => {
  return (
    <>
      <span>{getText(notification)}</span>

      <Link
        to={
          notification.data.flow_type === 'easy_builder'
            ? typedRouting.linkBuilder.easyBuilder({
                flow_id: notification.data.flow_ns,
              })
            : typedRouting.linkBuilder.cmsFiles({ fso_path: notification.data.flow_ns })
        }
        className={cm.link}
      >
        {l.translate('Open automation')}
      </Link>
    </>
  )
}
